import {
  PaymentIntent,
  PaymentMethod,
  PaymentRequestItem,
  PaymentRequest
} from '@stripe/stripe-js'
import React from 'react'
import { Context } from 'react'
export enum LOCAL {
  ZH = 'zh',
  EN = 'en'
}

export enum StripeInitStatus {
  FAIL = 'fail',
  SUCCESS = 'success',
  WAITING = 'waiting'
}

export enum PaymentType {
  BankCard_CreditCard = 'bank_card',
  Wallet_ApplePay = 'apple_pay',
  Wallet_GooglePay = 'google_pay',
  UNKNOW = 'UN'
  // WePay = "we_pay",
  // AliPay = "ali_pay",
}
export type PromiseResult = {
  result: boolean
  message: string
  data: any
}
export type StripPaymentIntentResult = {
  data: {
    paymentId: string
    paymentIntent: PaymentIntent
  }
}
export type CardPaymentMethodInfo = {
  paymentMethodId: string
  card: PaymentMethod.Card
  customer: string | null
  paymentType: PaymentType
  metadata: {
    [name: string]: string
  }
}

export type AssetsSetting = {
  addNewCreditCardBackground?: string
  entryCardNumberLabelClass: string
}

export type AssetsContext = {
  assetsSetting: AssetsSetting
}

export type BrowserPaymentRequestInitialization = {
  applePayIsSupport: boolean
  googlePayIsSupport: boolean
  paymentRequest: PaymentRequest | null
}

export type ChowbusStripePaymentContextData = {
  browserPaymentRequestInitialized: BrowserPaymentRequestInitialization | null
  paymentRequestInfo: PaymentRequestInfo | null
  cardPaymentMethodInfo: CardPaymentMethodInfo | null
  onCreditCardMethodRequest: (() => void) | null
  onCancelCreditCardMethodRequest: (() => void) | null
  showPaymentDoing: () => void
  closePaymentDoing: () => void
}

export const StripeAssetsContext: Context<AssetsContext> =
  React.createContext<AssetsContext>({
    assetsSetting: {
      addNewCreditCardBackground: '',
      entryCardNumberLabelClass: ''
    }
  })

export type PaymentRequestInfo = {
  guestId: string
  restaurantId: string
  restaurantName: string
  orderId: string
  country?: string
  currency?: string
  payAmount: number
  // This `PaymentRequestItem` is shown to the customer in the browser’s payment interface.
  billTotalDisplayItem: PaymentRequestItem
  billDetailDisplayItems: PaymentRequestItem[]
  //collect customer info when pay by wallet
  wallet: {
    /**
     * By default, the browser's payment interface only asks the customer for actual payment information.
     * A customer name can be collected by setting this option to `true`.
     * This collected name will appears in the `PaymentRequestEvent` object.
     *
     * We highly recommend you collect at least one of name, email, or phone as this also results in collection of billing address for Apple Pay.
     * The billing address can be used to perform address verification and block fraudulent payments.
     * For all other payment methods, the billing address is automatically collected when available.
     */
    requestPayerName?: boolean

    /**
     * See the `requestPayerName` option.
     */
    requestPayerPhone?: boolean

    /**
     * See the `requestPayerName` option.
     */
    requestPayerEmail?: boolean
  }

  metaData?: { [key: string]: string }
}

export enum IntegrationModel {
  LAZY = 'LAZY_MODEL',
  POSITIVE = 'POSITIVE_MODEL'
}
